// TODO: API HAS MOST LIKELY CHANGED
export function formatKnownImplied(parsed) {
    if (!parsed) {
        return null;
    }
    const merged = {
        month: parsed.knownValues.month || parsed.impliedValues.month,
        day: parsed.knownValues.day || parsed.impliedValues.day,
        year: parsed.knownValues.year || parsed.impliedValues.year,
        hour: parsed.knownValues.hour || parsed.impliedValues.hour,
        minute: parsed.knownValues.minute || parsed.impliedValues.minute,
    };
    return new Date(`${merged.month || ""} ${merged.day || ""} ${merged.year || ""} ${merged.hour || "00"}:${merged.minute || "00"}:00`);
}
